// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { MedicarePayerResponseModel } from './medicarePayerResponseModel.js';
import type { ReportType } from './reportType.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class MedicareReportResponseModel {
    'type'?: ReportType;
    'payers'?: Array<MedicarePayerResponseModel>;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof MedicareReportResponseModel>> = [
        {
            "name":     "type",
            "baseName": "type",
            "type":     "ReportType"
        },
        {
            "name":     "payers",
            "baseName": "payers",
            "type":     "Array<MedicarePayerResponseModel>"
        },
    ];

    static getAttributeTypeMap() {
        return MedicareReportResponseModel.attributeTypeMap;
    }
}
